export const QUERY_KEY_POINT_TEMPLATES_SINGLE_VOYAGES = 'point_templates_single_voyage'
export const QUERY_KEY_POINT_TEMPLATES_BY_IDS_SINGLE_VOYAGES = 'point_templates_by_ids_single_voyage'
export const QUERY_KEY_POINT_TEMPLATE_BY_ID_SINGLE_VOYAGES = 'point_template_by_id_single_voyage'
